/**
 * @generated SignedSource<<513dd842b2943ca92cdc3a33e197d3f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineTemplateStoreDetailQuery$variables = {
  routineId: string;
  storeId: string;
};
export type WorkspaceRoutineTemplateStoreDetailQuery$data = {
  readonly routine: {
    readonly id: string;
    readonly title: string;
  } | null;
  readonly store: {
    readonly id: string;
    readonly name: string;
    readonly routinesFromTemplate: ReadonlyArray<{
      readonly currentOccasion: {
        readonly issueCount: number;
        readonly sequenceNumber: number;
        readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion">;
      } | null;
      readonly currentSchedule: {
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemSchedule_schedule">;
      } | null;
      readonly id: string;
      readonly title: string;
    }>;
  };
};
export type WorkspaceRoutineTemplateStoreDetailQuery = {
  response: WorkspaceRoutineTemplateStoreDetailQuery$data;
  variables: WorkspaceRoutineTemplateStoreDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "routineId"
    }
  ],
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storeId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "templateId",
    "variableName": "routineId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceRoutineTemplateStoreDetailQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routinesFromTemplate",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentSchedule",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceRoutinesListItemSchedule_schedule"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "currentOccasion",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RoutineOccasionStatusCircle_RoutineOccasion"
                  },
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceRoutineTemplateStoreDetailQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routinesFromTemplate",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentSchedule",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isRoutineSchedule"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineScheduleDailyWeekday",
                        "kind": "LinkedField",
                        "name": "weekdays",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "weekday",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Time",
                            "kind": "LinkedField",
                            "name": "startTime",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hour",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minute",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RoutineScheduleDaily",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDay",
                        "storageKey": null
                      }
                    ],
                    "type": "RoutineScheduleMonthly",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startWeekday",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endWeekday",
                        "storageKey": null
                      }
                    ],
                    "type": "RoutineScheduleWeekly",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "currentOccasion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "calculateNoTasks",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "calculateNotCompletedStarted",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expireAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deadlineAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1462dfa0eaeba2f953283358f1817371",
    "id": null,
    "metadata": {},
    "name": "WorkspaceRoutineTemplateStoreDetailQuery",
    "operationKind": "query",
    "text": "query WorkspaceRoutineTemplateStoreDetailQuery(\n  $routineId: ID!\n  $storeId: ID!\n) {\n  routine(id: $routineId) {\n    id\n    title\n  }\n  store(id: $storeId) {\n    id\n    name\n    routinesFromTemplate(templateId: $routineId) {\n      id\n      title\n      currentSchedule {\n        __typename\n        ...WorkspaceRoutinesListItemSchedule_schedule\n      }\n      currentOccasion {\n        ...RoutineOccasionStatusCircle_RoutineOccasion\n        sequenceNumber\n        issueCount\n        id\n      }\n    }\n  }\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment WorkspaceRoutinesListItemScheduleDaily_schedule on RoutineScheduleDaily {\n  weekdays {\n    weekday\n    startTime {\n      hour\n      minute\n    }\n  }\n}\n\nfragment WorkspaceRoutinesListItemScheduleMonthly_schedule on RoutineScheduleMonthly {\n  startDay\n  endDay\n}\n\nfragment WorkspaceRoutinesListItemScheduleWeekly_schedule on RoutineScheduleWeekly {\n  startWeekday\n  endWeekday\n}\n\nfragment WorkspaceRoutinesListItemSchedule_schedule on RoutineSchedule {\n  __isRoutineSchedule: __typename\n  __typename\n  ... on RoutineScheduleDaily {\n    ...WorkspaceRoutinesListItemScheduleDaily_schedule\n  }\n  ... on RoutineScheduleMonthly {\n    ...WorkspaceRoutinesListItemScheduleMonthly_schedule\n  }\n  ... on RoutineScheduleWeekly {\n    ...WorkspaceRoutinesListItemScheduleWeekly_schedule\n  }\n}\n"
  }
};
})();

(node as any).hash = "02d9562d3326f8a076e6cd387862df6d";

export default node;
